import { render, staticRenderFns } from "./detail-list.vue?vue&type=template&id=377618ba&scoped=true"
import script from "./detail-list.vue?vue&type=script&lang=js"
export * from "./detail-list.vue?vue&type=script&lang=js"
import style0 from "./detail-list.vue?vue&type=style&index=0&id=377618ba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377618ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\mrzhj\\Desktop\\ff\\frontent\\takeout\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('377618ba')) {
      api.createRecord('377618ba', component.options)
    } else {
      api.reload('377618ba', component.options)
    }
    module.hot.accept("./detail-list.vue?vue&type=template&id=377618ba&scoped=true", function () {
      api.rerender('377618ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/serve/detail-list.vue"
export default component.exports